<script>
    import NauiCheckbox from "../atoms/NauiCheckbox.svelte";
    import NauiState from "../atoms/NauiState.svelte";
    import NauiTag from "../atoms/NauiTag.svelte";
    import NauiButton from "../atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";
    import NauiInput from "../atoms/NauiInput.svelte";

    const dispatch = createEventDispatcher();

    export let type = 'text';
    export let inputType = 'text';
    export let slug = '';
    export let data = null;
    export let selected = null;
    export let options = null;

    let fileLabel = 'Arrastre el archivo o haga click aquí.';

    function dispatchAction(actionSlug, evData) {
        const actionData = {action: actionSlug, slug: slug};
        if (evData != null) {
            data = evData;
            actionData.data = data;
        }
        dispatch('action', actionData);
    }

    /* keep&go */
    function fileChanged(ev) {
        const file = ev.target.files[0];
        if (file) {
            fileLabel = file.name;
        } else {
            fileLabel = 'Arrastre el archivo o haga click aquí.';
        }

        dispatch('file', {file, slug});
    }

    $:if (type === 'input') {
        dispatch('update', data)
    }

    function numberInput(data, event, plus) {
        console.log(event);
        if (plus) {
            dispatchAction('data', Math.max(data + plus, 0));
            return;
        }
        if (event) {
            let cast = +event;
            if (!isNaN(cast)) {
                dispatchAction('data', Math.max(cast, 0));
            }
        }
    }
</script>
<div class="w-100">
    {#if type === 'text'}
        {data}
    {:else if type === 'checkbox'}
        <NauiCheckbox label="" bind:value={selected}/>

    {:else if type === 'state'}
        <NauiState code={data.code} label={data.label}/>

    {:else if type === 'tag'}
        <NauiTag label="{data.label}" textColor="{data.textColor}" backColor="{data.backColor}"
                 borderColor="{data.backColor}"/>
    {:else if type === 'date'}
        <div class="naui-date text-c" style="width:100px">{data}</div>
    {:else if type === 'input'}
        {#if inputType === 'text'}
            <input class="naui-input" type="text" bind:value={data} on:change on:input>
        {:else if inputType === 'date'}
            <input class="naui-input" type="date" bind:value={data} on:change on:input>
        {:else if inputType === 'number'}
            <input class="naui-input" type="number" bind:value={data} on:change on:input>
        {:else}
            <input class="naui-input" type="text" bind:value={data} on:change on:input>
        {/if}
    {:else if type === 'select'}
        <select class="naui-input w-100">
            {#each options as option}
                <option value={option.value}>{option.label}</option>
            {/each}
        </select>

    {:else if type === 'icon'}
        <i style="font-size: 1.2rem"
           class="{data.iconFamily ? data.iconFamily: 'fal'} fa-{data.icon} {data.color ? data.color : ''}"></i>

    {:else if type === 'actions'}
        <div class="box sx-1">
            {#each data || [] as action}
                {#if action.disabled}
                    <div style="opacity: .35; filter: grayscale(100%); pointer-events: none;">
                        <NauiButton href={action.route} icon="{action.icon}"
                                    iconFamily="{action.iconFamily ? action.iconFamily : 'fal'}"
                                    color="{action.color ? action.color : 'accent'}" disabled/>
                    </div>
                {:else if action.route}
                    <NauiButton href={action.route} icon="{action.icon}"
                                iconFamily="{action.iconFamily ? action.iconFamily : 'fal'}"
                                color="{action.color ? action.color : 'accent'}" download="{action.download}"/>
                {:else}
                    <NauiButton icon="{action.icon}"
                                iconFamily="{action.iconFamily ? action.iconFamily : 'fal'}"
                                color="{action.color ? action.color : 'accent'}"
                                on:click={() => dispatchAction(action.slug)}/>
                {/if}
            {/each}
        </div>

    {:else if type === 'list'}
        {data.map(i => i.label.trim()).join(', ')}
        <!-- Keep&go -->
    {:else if type === 'numberInput'}
        <div class="box-l sx-1">
            <NauiButton icon="minus-circle" iconFamily="fal" color="accent"
                        on:click={() => {numberInput(data, null, -1)}}/>
            <NauiInput bind:value={data} label="" type="number" step="0.1"
                       on:input={(ev) => {numberInput(data, ev.target.value)}}/>
            <NauiButton icon="plus-circle" iconFamily="fal" color="accent"
                        on:click={() => {numberInput(data, null, 1)}}/>
        </div>
    {:else if type === 'file'}
        <div class="box-l sx-1">
            <label class="file-input">
                {fileLabel}
                <input type="file" on:change={fileChanged}>
            </label>
        </div>
    {/if}
</div>
<style>
    label.file-input {
        border: 1px dashed #999;
        padding: 10px;
        margin: 10px;
        position: relative;
    }

    .file-input input {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }
</style>
